module.exports = __webpack_public_path__ + "media/images/avatar/development/nannies/13-38c54c33d3209fe9a78b911b247e3c97.jpg";